import { EngageApi } from "field-pulse-js-sdk";

console.log("[Engage:Env]", process.env.NODE_ENV)
const Engage = new EngageApi({ mode: process.env.NODE_ENV });

export default Engage;
